import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-copy-to-clipboard-dialog',
  templateUrl: './copy-to-clipboard-dialog.component.html',
  styleUrls: ['./copy-to-clipboard-dialog.component.scss']
})
export class CopyToClipboardDialogComponent implements OnInit {

  copiedVideoFullUrl: string;
  constructor(
    private dialogRef: MatDialogRef<CopyToClipboardDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data,
        public notifier: NotifierService,
  ) {
    this.copiedVideoFullUrl = data.videoFullUrl;
   }

  ngOnInit(): void {
  }

  copyVideoUrl() {
      let copyText = document.getElementById("currentlyHiddenVidoeId") as HTMLInputElement;
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyText.value);
      this.notifier.notify('success','Link copied successfully');
  }
 
  close() {
    this.dialogRef.close();
  }
}
